/**
 * Utility function to create a delay using Promise and setTimeout
 * @param ms - The number of milliseconds to delay
 * @returns A Promise that resolves after the specified delay
 */
export async function delay(ms: number): Promise<void> {
  // eslint-disable-next-line promise/avoid-new
  return new Promise<void>(resolve => setTimeout(resolve, ms))
}